import React from 'react';
export const Footer = () => {
  return <footer className="bg-navy py-8 px-6 text-cream text-center" data-id="element-125">
      <div className="max-w-4xl mx-auto" data-id="element-126">
        <p className="text-lg font-semibold mb-4" data-id="element-127">¿DÓNDE SE VA MI DINERO?</p>
        <p className="serif-text mb-6" data-id="element-128">
          La guía latina para controlar tu quincena, dejar de sufrir a fin de
          mes y construir libertad financiera
        </p>
        <p data-id="element-129">&copy; {new Date().getFullYear()} Todos los derechos reservados</p>
      </div>
    </footer>;
};